<template>
  <MainLayoutV2 section="team">
    <div id="team_container">
      <div id="team_subcontainer">
        <h1>Our Team</h1>
  
        <p id="team_summary">Coming from top enterprises, meet the talent behind <b>Dev Null Productions</b></p>
  
        <div id="team">
          <div id="team_member_container"
            v-for="member of team"
            :key="member.id">
            <div id="team_member" v-b-modal="'team-modal-' + member.id">
              <img id="member_img" :src="member_img(member)" />
  
              <p id="member_name">{{member.name}}</p>
              <p id="member_title">{{member.title}}</p>
  
              <div class="spacer">&nbsp;</div>
              <p id="member_read_bio">
                <span>
                  Read Bio
                  <img src="@/assets/imgs/new_arrow-right.svg" style="width: 16px"/>
                </span>
              </p>
            </div>
  
            <b-modal :id="'team-modal-' + member.id"
              hide-header hide-footer centered
              size="lg" content-class="team_modal">
  
              <div id="team_modal_close" @click="$bvModal.hide('team-modal-' + member.id)">
                Close
                <img src="@/assets/imgs/new_close.svg" style="width: 12px"/>
              </div>
  
              <div id="team_modal_container">
                <img :src="member_img(member)" />
                <div id="team_modal_subcontainer">
                  <p id="member_name">{{member.name}}</p>
                  <p id="member_title">{{member.title}}</p>
                  <p id="member_summary">{{member.summary}}</p>
                </div>
              </div>
            </b-modal>
          </div>
        </div>
      </div>
    </div>
  </MainLayoutV2>
</template>

<script>
import MainLayoutV2 from '@/components/V2/layout/MainLayoutV2'
import team from '@/assets/team.json'

export default {
  name: 'TeamV2',

  components: {
    MainLayoutV2
  },

  data : function(){
    return {
      team
    }
  },

  methods : {
    member_img : function(member){
      return require("../../assets/team/" + member.image);
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/scss/custom.scss';

#team_container{
  background-image: url("~@/assets/imgs/team-background.png");
  background-repeat: no-repeat;
  background-size: 100% 650px;
}

#team_subcontainer{
  width: 60%;
  margin: auto;
  margin-bottom: 50px;
  padding-top: 325px;
  color: $white;
  font-family: Alliance No2;
}

#main_layout_v2.md #team_subcontainer,
#main_layout_v2.xs #team_subcontainer{
  width: 80%;
}

#main_layout_v2.sm #team_subcontainer{
  width: 90%;
}

#team_subcontainer h1{
  font-family: Sunset Gothic Pro Heavy;
  text-align: center;
}

#team_summary{
  text-align: center;
  margin-bottom: 150px;
}


#team{
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

#main_layout_v2.xs #team{
  justify-content: center;
  gap: unset;
}

#team_member_container{
  background-image: linear-gradient($grey-5, $black);
  padding: 10px;
  border-radius: 15px;
  min-width: 32%;
  max-width: 32%;
  height: 350px;
  width: 350px;
  margin-bottom: 25px;
  cursor: pointer;
}

#main_layout_v2.xs #team_member_container{
  min-width: unset;
  max-width: unset;
}

#team_member{
  height: 100%;
  display: flex;
  flex-direction: column;
}

#member_img{
  border-radius: 15px;
  width: 95%;
  height: 220px;
  margin: auto;
  margin-bottom: 5px;
}

#team_member p{
  margin-bottom: 0;
}

#member_read_bio{
  align-self: end;
  margin-right: 10px;
}

#member_read_bio span{
  font-family: Bricolage Grotesque ExtraBold;
  font-size: 0.9rem;
  border-bottom: 1px solid $sunset-coral;
}

.spacer{
  flex-grow: 1;
}
</style>

<style lang="scss">
@import '@/scss/custom.scss';
.team_modal{
  background-image: linear-gradient(-175deg, $grey-5, $black 50%);
  border-radius: 15px;
  color: $white;
  display: flex;
  flex-direction: column;
}

#team_modal_close{
  font-family: Bricolage Grotesque ExtraBold;
  font-size: 0.8rem;
  width: fit-content;
  margin-left: auto;
  margin-bottom: 5px;
  margin-right: 5px;
  border-bottom: 1px solid $sunset-coral;
  cursor: pointer;
}

#team_modal_close img{
  position: relative;
  top: -1px;
}

#team_modal_container{
  background-image: linear-gradient(-175deg, $grey-5, $black 50%);
  border-radius: 15px;
  display: flex;
  padding: 15px;
}

#team_modal_container img{
  width: 250px;
  margin-right: 15px;
  border-radius: 15px;
}

#team_modal_container p{
  margin-bottom: 5px;
}

#member_name{
  font-family: Sunset Gothic Pro Heavy;
}

#member_title{
  font-family: Bricolage Grotesque ExtraBold;
  font-size: 0.8rem;
  color: $sunset-coral;
}

</style>
